import { render, staticRenderFns } from "./ModalLawConsult.vue?vue&type=template&id=aabf015e&"
import script from "./ModalLawConsult.vue?vue&type=script&lang=js&"
export * from "./ModalLawConsult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports